/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_IdentityInputs */

const cs_clients_create_identity = /** @type {(inputs: Clients_Create_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identita`)
};

const en_clients_create_identity = /** @type {(inputs: Clients_Create_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identity`)
};

/**
* | output |
* | --- |
* | "Identity" |
*
* @param {Clients_Create_IdentityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_create_identity = /** @type {((inputs?: Clients_Create_IdentityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_IdentityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_identity(inputs)
	return cs_clients_create_identity(inputs)
});